import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { Warning, Info, X } from '@phosphor-icons/react';

export const BroadcastBanner = () => {
  const qc = useQueryClient();
  const { data: broadcasts } = useQuery({
    queryKey: ['broadcasts-active'],
    queryFn: () => api.get('/broadcasts/active').then((r) => r.data),
    refetchInterval: 20000,
  });
  const dismissMut = useMutation({
    mutationFn: (id) => api.post(`/broadcasts/${id}/dismiss`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['broadcasts-active'] }),
  });

  if (!broadcasts || broadcasts.length === 0) return null;

  return (
    <div data-testid="broadcast-banners">
      {broadcasts.map((b) => {
        const urgent = b.level === 'urgent';
        return (
          <div key={b.id} data-testid={`broadcast-${b.id}`}
            className={`flex items-start gap-3 px-4 sm:px-6 py-3 border-b ${urgent ? 'bg-rose-600 border-rose-700 text-white' : 'bg-orange-50 border-orange-200 text-orange-900'}`}>
            {urgent ? <Warning size={20} weight="fill" className="shrink-0 mt-0.5" /> : <Info size={20} weight="fill" className="shrink-0 mt-0.5 text-orange-600" />}
            <div className="flex-1 min-w-0">
              <p className="font-display font-bold text-sm">{b.title}</p>
              <p className={`text-sm ${urgent ? 'text-rose-50' : 'text-orange-800'}`}>{b.body}</p>
            </div>
            <button data-testid={`broadcast-dismiss-${b.id}`} onClick={() => dismissMut.mutate(b.id)}
              className={`shrink-0 rounded p-1 transition-colors ${urgent ? 'hover:bg-rose-500' : 'hover:bg-orange-100'}`} title="Dismiss">
              <X size={16} weight="bold" />
            </button>
          </div>
        );
      })}
    </div>
  );
};
